export default __webpack_public_path__ + "static/media/contact-us-illustration.671f00eb.svg";